module.exports = __webpack_public_path__ + "img/diff_attr_image_icon.650a48a.png";